import { createReducer, on } from '@ngrx/store';
import { setDepartmentListPageNumber, setDepartmentListItemsPerPage, setMemberListPageNumber, setMemberListItemsPerPage, setRoleListItemsPerPage, setRoleListPageNumber } from '../actions/security.action';

export interface SecurityState {
    pageNumberDepartmentList: number;
    itemsPerPageDepartmentList: number;
    pageNumberMemberList: number;
    itemsPerPageMemberList: number;
    pageNumberRoleList: number;
    itemsPerPageRoleList: number;
}

export const initialState: SecurityState = {
    pageNumberDepartmentList: 1,
    itemsPerPageDepartmentList: 10,
    pageNumberMemberList: 1,
    itemsPerPageMemberList: 10,
    pageNumberRoleList: 1,
    itemsPerPageRoleList: 10,
};

export const securityReducer = createReducer(
    initialState,
    on(setDepartmentListPageNumber, (state, { pageNumberDepartmentList }) => ({ ...state, pageNumberDepartmentList })),
    on(setDepartmentListItemsPerPage, (state, { itemsPerPageDepartmentList }) => ({ ...state, itemsPerPageDepartmentList })),
    on(setMemberListPageNumber, (state, { pageNumberMemberList }) => ({ ...state, pageNumberMemberList })),
    on(setMemberListItemsPerPage, (state, { itemsPerPageMemberList }) => ({ ...state, itemsPerPageMemberList })),
    on(setRoleListPageNumber, (state, { pageNumberRoleList }) => ({ ...state, pageNumberRoleList })),
    on(setRoleListItemsPerPage, (state, { itemsPerPageRoleList }) => ({ ...state, itemsPerPageRoleList })),
);